import { environment } from './../environments/environment';
import { OnInit, Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  constructor () {
    console.log(environment.production);
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  ngOnInit() {
    // this.initLanding();
  }

  private initLanding() {
    const myLanding = document.getElementById('myLanding');

    function addClass(myClass: string) {
      myLanding.classList.add(myClass);
    }

    document.addEventListener('DOMContentLoaded', function() {
      // @ts-ignore
      setTimeout(addClass('background'), 1400);

      // @ts-ignore
      // setTimeout(addClass('blur'), 1600);

      // @ts-ignore
      setTimeout(addClass('logo'), 1600);

      // @ts-ignore
      setTimeout(addClass('hide'), 1800);
    });

  }
}
